import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGift, faMapMarkerAlt, faCity, faStar, faGlobe, faBook, faBookOpen, faDownload, faGifts, faHandsHelping, faPhone, faRainbow, faShoppingCart, faStore, faVideo, faQrcode } from '@fortawesome/free-solid-svg-icons';
import './MADSmania.css';
import madsmaniaimage from '../../assets/pageimages/MADSmania.webp';

function MADSmaniaVOGABGym() {

  return (
    <MainLayout>
      <div>
        <h2 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>MADSmania - Engagement With Maths & Other Subjects</h2>
      </div>
      <div className="main-content">
      <div className="top-section top-section mt-4 ml-2 mr-0 border border-b-gray-300">
          <div className="button-links flex align-middle justify-center bg-gray-500">
            <div className="bottom-buttons-box"><Link to="/madsmania-mnpsolo" className="top-button-link"><FontAwesomeIcon icon={faQrcode} className="madsmania-bottomlink-style" />MNP Solo</Link></div>
            <div className="bottom-buttons-box"><Link to="/madsmania-formulagym" className="top-button-link"><FontAwesomeIcon icon={faQrcode} className="madsmania-bottomlink-style" />Formula Gym</Link></div>
            <div className="bottom-buttons-box"><Link to="/madsmania-vogabgym" className="top-button-link"><FontAwesomeIcon icon={faQrcode} className="madsmania-bottomlink-style" />VOAGB Gym</Link></div>
            <div className="bottom-buttons-box"><Link to="/madsmania-ptgym" className="top-button-link"><FontAwesomeIcon icon={faStar} className="madsmania-bottomlink-style" />Periodic Table</Link></div>
          </div>
        </div>
        <div className="image-container">
          <div className="relative inset-0 flex border border-b-gray-300">
            <img id="madsmania-id" src={madsmaniaimage} alt="MADSmania Image" />
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default MADSmaniaVOGABGym;
